import {
  createEntityAdapter,
  createSlice,
  createSelector,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { ProcessStage } from 'types/store/normalized/projectProcess';

const stagesAdapter = createEntityAdapter<ProcessStage>();
const initialState = stagesAdapter.getInitialState();

const stagesSlice = createSlice({
  name: 'projectsList/include/stages',
  initialState,
  reducers: {
    updateStages: (
      state,
      action: PayloadAction<{
        stages: ProcessStage[];
        shouldReplace: boolean;
      }>
    ) => {
      const { stages, shouldReplace } = action.payload;
      if (shouldReplace) {
        stagesAdapter.setAll(state, stages);
      } else {
        stagesAdapter.upsertMany(state, stages);
      }
    },
    removeAllStages: (state) => {
      stagesAdapter.removeAll(state);
    },
  },
});

export const { updateStages, removeAllStages } = stagesSlice.actions;

const selectStages = (state: RootState) => state.projectsList.include.stages;

export const { selectAll: selectAllStages, selectById: selectStageById } =
  stagesAdapter.getSelectors<RootState>(selectStages);

export const selectStagesById = createSelector(
  [selectAllStages, (_, stages: string[]) => stages],
  (stages, stagesIds) => {
    return stages.filter((stage) => stagesIds.includes(stage.id));
  }
);

export default stagesSlice.reducer;
